export function hasAccessToProduct({
  userUnits,
  productId,
}: {
  userUnits?: Record<string, any>[];
  productId: number;
}): boolean {
  if (!userUnits) return false;

  return userUnits?.some(item =>
    item.userUnitProductRoles.some((role: {productId: number}) => role.productId === productId)
  );
}
